import { useId } from 'react';
import { Switch } from '@/components/ui';

export interface PolicyToggleRowProps {
  label: string;
  description?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (next: boolean) => void;
  testId?: string;
}

/**
 * 라벨 + 보조설명 + 우측 토글 1행. 주문 기본설정의 bool 4필드 공용 레이아웃.
 * label 을 Switch 와 연결(htmlFor)해 라벨 클릭으로도 토글되도록 한다.
 */
export const PolicyToggleRow = ({
  label,
  description,
  checked,
  disabled,
  onChange,
  testId,
}: PolicyToggleRowProps) => {
  const id = useId();
  return (
    <div className="flex items-start justify-between gap-4 py-3">
      <div className="flex flex-col gap-0.5">
        <label
          htmlFor={id}
          className="text-sm font-medium text-[color:var(--content-strong)]"
        >
          {label}
        </label>
        {description ? (
          <span className="text-xs text-[color:var(--content-muted)]">{description}</span>
        ) : null}
      </div>
      <Switch
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
        data-testid={testId}
      />
    </div>
  );
};
